import { Grid, Input } from '@material-ui/core';
import { TextFieldProps } from '@material-ui/core/TextField';
import * as React from 'react';
import { useCallback } from 'react';
import i18n from 'src/resources/i18n';
/**
 * DateInputFieldsの値型
 */
export interface IDateInputFieldsValue {
	/** 日 */
	day: string;
	/** 月 */
	month: string;
	/** 年 */
	year: string;
}

/** DateInputFields用State */
export interface IDateInputFieldsState {
	value: IDateInputFieldsValue;
}

/** DateInputFields用イベント */
export interface IDateInputFieldsEvents {
	onChange?: (value: IDateInputFieldsValue) => void;
}

/** DateInputFields用Props型 */
export interface IDateInputFieldsProps
	extends IDateInputFieldsState,
		IDateInputFieldsEvents {}

/**
 * TextField
 * @param props
 */
const TextGrid: React.FC<{
	onChange?: TextFieldProps['onChange'];
	placeholderKey: string;
	value: string;
}> = ({ onChange, placeholderKey, value }) => (
	<Grid item={true} xs={4}>
		<Input
			onChange={onChange}
			placeholder={i18n.t(placeholderKey)}
			value={value}
			disableUnderline={true}
		/>
	</Grid>
);

/**
 * TextField毎のonChangeイベント共通部分
 * @param onChange 親コンポ―ネントに渡すイベント
 * @param create 値オブジェクト生成関数
 */
const onChangeField = (
	onChange: IDateInputFieldsProps['onChange'],
	create: (arg: string) => IDateInputFieldsValue
): Exclude<TextFieldProps['onChange'], undefined> => e => {
	if (onChange) {
		onChange(create(e.target.value));
	}
};

/**
 * 年月日3種をまとめて入力するTextFieldセット
 */
export const DateInputFields: React.FC<IDateInputFieldsProps> = ({
	onChange,
	value: { day, month, year },
}) => {
	const onChangeYear = useCallback(
		onChangeField(onChange, y => ({ day, month, year: y })),
		[onChange, day, month]
	);
	const onChangeMonth = useCallback(
		onChangeField(onChange, m => ({ day, month: m, year })),
		[onChange, day, year]
	);
	const onChangeDay = useCallback(
		onChangeField(onChange, d => ({ day: d, month, year })),
		[onChange, month, year]
	);

	return (
		<Grid container={true}>
			<TextGrid
				onChange={onChangeYear}
				placeholderKey={i18n.t('DateInputFields_0001')}
				value={year}
			/>
			<TextGrid
				onChange={onChangeMonth}
				placeholderKey={i18n.t('DateInputFields_0002')}
				value={month}
			/>
			<TextGrid
				onChange={onChangeDay}
				placeholderKey={i18n.t('DateInputFields_0003')}
				value={day}
			/>
		</Grid>
	);
};



// WEBPACK FOOTER //
// ./src/components/DateInputFields.tsx